import React from 'react';
import { ENTITY_CONSTANTS } from '../../common/constants/entityConstants';
import { FORM_WIDGET_COMPONENTS } from '../../common/form/formConstants';
import { FormContainer } from '../../common/form/FormContainer';
import FormItem from '../../common/form/FormItem';
import FormPanel from '../../common/form/FormPanel';
import FormWidget from '../../common/form/FormWidget';

export default () => {
    return (
        <FormPanel>
            <FormContainer>
                <FormItem>
                    <FormWidget
                        name="entityMulti"
                        label="Person Multiple Entity Object"
                        component={FORM_WIDGET_COMPONENTS.entityAutocomplete}
                        entity={ENTITY_CONSTANTS.person}
                        multiple
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        name="entitySingle"
                        label="Person Entity Object"
                        component={FORM_WIDGET_COMPONENTS.entityAutocomplete}
                        entity={ENTITY_CONSTANTS.person}
                    />
                </FormItem>
            </FormContainer>
            <FormContainer>
                <FormItem>
                    <FormWidget
                        name="orgShowInactive"
                        label="Organization (show inactive)"
                        component={FORM_WIDGET_COMPONENTS.entityAutocomplete}
                        entity={ENTITY_CONSTANTS.organization}
                        showInactive
                    />
                </FormItem>
                <FormItem>
                    <FormWidget
                        name="orgHideInactive"
                        label="Organization (hide inactive)"
                        component={FORM_WIDGET_COMPONENTS.entityAutocomplete}
                        entity={ENTITY_CONSTANTS.organization}
                    />
                </FormItem>
            </FormContainer>
        </FormPanel>
    );
};
